import { Component, OnInit } from '@angular/core';
import { Authorization, UserDto } from '../models/data.model';
import { CommonService } from '../services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthGuardService } from '../services/authGuard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../services/data.service';
import { LocalSettingsService } from '../services/local-settings.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  Username: string = '';
  Password: string = '';
  return: string = '';
  loginForm: FormGroup;
  submitted = false;
  id: string;
  idutente: string;
  idallegato: string;

  constructor(private service: CommonService<Authorization>,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthGuardService,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private storageService: LocalSettingsService,
    private toastr: ToastrService) { }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

  /* Tabellina dei possibili indirizzi in eportal: evolutive ottobre 2022

Utente NON loggato: i seguenti URL portano alla pagina di login

http://localhost:6003/login
http://localhost:6003/home
http://localhost:6003/
http://localhost:6003/[stringa] : NO = Pagina bianca, premendo Invio o refresh si va alla pagina di login
http://localhost:6003/arcadocqualita-detail/[id] : accesso da notifica = dopo il login porta al documento
http://localhost:6003/login/arcadocqualita-[id] : accesso da notifica = dopo il login porta al documento
http://localhost:6003/international-activities-detail/[id] : accesso da notifica = dopo il login porta al documento
http://localhost:6003/login/international-activities-detail-[id] : accesso da notifica = dopo il login porta al documento
http://localhost:6003/listini-vendita
http://localhost:6003/arcadocqualita/Arcadocqualita
http://localhost:6003/international-activities-detail
http://localhost:6003/international-activities/[linea] es. linea = US_SMKT
http://localhost:6003/arcadocqualita-detail/[stringa] : dopo il login porta a una pagina bianca
http://localhost:6003/login/arcadocqualita-detail[stringa] : dopo il login porta a una pagina bianca
http://localhost:6003/international-activities-detail/[stringa] : dopo il login porta a una pagina bianca
http://localhost:6003/login/international-activities-detail-[stringa] : dopo il login porta a una pagina bianca

Utente loggato:

http://localhost:6003/home
http://localhost:6003/arcadocqualita-detail/[id] : accesso da notifica =  porta al documento
http://localhost:6003/international-activities-detail/[id] : accesso da notifica = porta al documento
http://localhost:6003/listini-vendita : porta alla home page del componente Listini vendita
http://localhost:6003/arcadocqualita/Arcadocqualita : porta alla home page del componente Equaltec
http://localhost:6003/international-activities/[linea] es. linea = US_SMKT porta alla home page del componente International Activities, differenziando per linea (US_SMKT o US_SER o VET_SMKT)
http://localhost:6003/login : porta alla pagina di login per un login ridondante
http://localhost:6003/arcadocqualita-detail/[stringa] : porta a una pagina bianca
http://localhost:6003/login/arcadocqualita-detail-[stringa] :  porta alla pagian di login
http://localhost:6003/login/arcadocqualita-detail[id] :  porta alla pagian di login
http://localhost:6003/international-activities-detail/[stringa] : porta a una pagina bianca
http://localhost:6003/login/international-activities-detail-[stringa] : porta alla pagina di login
http://localhost:6003/login/international-activities-detail-[id] : porta alla pagina di login
http://localhost:6003/[stringa] : NO = Pagina bianca, premendo Invio o refresh si va alla pagina home

*/ 


  ngOnInit() {
    let loginInfo = this.storageService.getCredential();
    this.loginForm = this.formBuilder.group({
      Username: [loginInfo.username ? loginInfo.username : '', Validators.required],
      Password: [loginInfo.password ? loginInfo.password : '', Validators.required], //, Validators.minLength(6)  
      rememberme:[false,null]          
    });

    // Get the query params
    this.route.queryParams
      .subscribe(params => {
        this.idutente = params['idutente'];
        this.idallegato = params['idallegato'];
      }
        //this.return = params['return'] || '/forums');
    )
    this.route.params.subscribe(p => {
      this.id = p['id'];
    });  
  }

  doLogin = () => {
     // 27/01/2025 - funzione deprecata che non viene utilizzata
    this.submitted = true;
    console.log(this.loginForm.value.Username);
    if (this.loginForm.invalid) {
      return;
    }
    console.log("this.id login=" + this.id);
    this.service.postData('api/auth/login', { username: this.loginForm.value.Username, password: this.loginForm.value.Password }, false).subscribe(result => {
      //console.log("result", result);
      if (result != null) {
        console.log('this is login result : ', result);
        this.authService.setLoggedIn(true);
        this.authService.setProfile(result);

        
        this.service.setPrincipal(result as Authorization);
        if(this.loginForm.value.rememberme){
          let loginInfo = new UserDto(); 
          loginInfo.username = this.loginForm.value.Username;
          //loginInfo.password = this.loginForm.value.Password
          this.storageService.setCredential(loginInfo);
        }
        /* GESTIONE acceso da notifica:
         * Da notifica possono arrivare da Arcadoc solo questi 2 url: http://localhost:6003/international-activities-detail/[id] e http://localhost:6003/arcadocqualita-detail/[id]
         * essi vanno prima direttamente al componente, se l'utente è già loggato entrano direttamente. Se l'utente non è loggato si è reindirizzati qui con i seguenti URL:
         * http://localhost:6003/login/arcadocqualita-detail-[id] e http://localhost:6003/login/international-activities-detail-[id]
         * this.id è tutto quello che c'è dolo l'URL http://localhost:6003/login/        *
         * Poichè http://localhost:6003/login/ è anche l'unico accesso all'applicazione NON da notifica, il seguente if (this.id == undefined)  smista i due soli soli possibili accessi all'applicazione:         
         * cioè se dopo http://localhost:6003/login/ non c'è nulla, allora c'è un accesso NON da notifica, quindi smisto alla home;
         * invece se dopo http://localhost:6003/login/ c'è qualcosa controllo che siano gli unici due URL che so provenire dalle notifiche.         *
         *Il controllo sembra codice cablato, in realtà, sebbene l'URL da notifica non può cambiare, si apre la porta all'accesso diretto per nuovi componenti o altre applcazioni oltre Arcadoc 
         */
        if (this.id == undefined) {
          this.router.navigate(['/']);
        } else {
          let d = this.id.split('-');     
          if (d[d.length - 3] + "-" + d[d.length - 2] == "arcadocqualita-detail") {
            this.router.navigate(['/arcadocqualita-detail', d[d.length - 1]], { queryParams: { idutente: this.idutente, idallegato: this.idallegato } });
          } else if (d[d.length - 4] + "-" +d[d.length - 3] + "-" + d[d.length - 2] == "international-activities-detail") {
            this.router.navigate(['/international-activities-detail', d[d.length - 1]], { queryParams: { idutente: this.idutente, idallegato: this.idallegato } });
          }
        }
        //console.log(this.service.getPrincipal());
      }
    }, error => {
      console.error(error);
      this.translate.get(["LOGIN.LOGINFAILTITLE","LOGIN.LOGINFAILMESSAGE"])
      .subscribe(values => {                           
        this.toastr.error(values["LOGIN.LOGINFAILMESSAGE"],values["LOGIN.LOGINFAILTITLE"]);
      });
      
    });
  }

}
